export const LOCATIONS_LOADING = "LOCATIONS_LOADING";
export const GET_LOCATIONS_SUCCESS = "GET_LOCATIONS_SUCCESS";
export const GET_LOCATIONS_FAILURE = "GET_LOCATIONS_FAILURE";
export const RESET_LOCATIONS = "RESET_LOCATIONS";
